import { get } from "lodash";
import moment from "moment";

// Serialize error objects to plain data to prevent Redux state mutation warnings.
// Raw HTTP errors contain mutable `request`/`response` objects that get mutated
// by the browser between dispatches, triggering Redux Toolkit's invariant checks.
const serializeError = (error) => {
  if (!error || typeof error === "string") return error;
  return {
    message: error.message || error.errorMessage || "An error occurred",
    ...(error.errorMessage && { errorMessage: error.errorMessage }),
    ...(error.status && { status: error.status }),
    ...(error.statusText && { statusText: error.statusText }),
    ...(error.success !== undefined && { success: error.success }),
  };
};

export const updaterState = {
  initUpdaterState: (entityState) => ({
    ...entityState,
    sending: false,
    sent: false,
    error: null,
  }),

  setUpdaterSending: (entityState) => ({
    ...entityState,
    sending: true,
    sent: false,
    error: null,
  }),

  setUpdaterSent: (entityState, data) => ({
    ...entityState,
    sending: false,
    sent: true,
    data,
    error: null,
  }),

  setUpdaterError: (entityState, error) => ({
    ...entityState,
    sending: false,
    sent: false,
    error: serializeError(error) || "failed",
  }),
};

export const loaderState = {
  initLoader: (entityState) => ({
    ...entityState,
    loading: false,
    loadTimestamp: null,
    data: null,
    error: null,
  }),

  setLoading: (entityState) => ({
    ...entityState,
    loading: true,
    loadTimestamp: moment().format(),
    error: null,
  }),

  setDataLoaded: (entityState, data) => ({
    ...entityState,
    loading: false,
    loadTimestamp: get(entityState, "loadTimestamp") || moment().format(),
    data,
    error: null,
  }),

  setError: (entityState, error) => ({
    ...entityState,
    loading: false,
    loadTimestamp: entityState.loadTimestamp,
    error: serializeError(error),
  }),

  resetErrorAndLoading: (entityState) => ({
    ...entityState,
    loading: false,
    error: null,
  }),
};
